//
// locales/vanilla/br.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/br.json';
import localeData from 'react-intl/locale-data/br.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
